export default __webpack_public_path__ + "static/media/galaxis.aa215dcd.png";